// Import necessary Material-UI components
import Grid from "@mui/material/Grid";
// Import custom components
import { SampleRequestDetails, ItemList } from ".";
// Import custom CSS for styling
import "../viewRequests/frosted.css";
// Import custom hook for accessing the new request context
import { useNewRequestContext } from "../hooks";

/**
 * ViewRequestDetails component for rendering request details
 * @param {Object} props - Component props including data, and callbacks.
 */
export function ViewRequestDetails(props) {
  // Access the current state of the new request using the custom hook
  const { state } = useNewRequestContext();

  return (
    <Grid
      container
      justifyContent="center"
      rowSpacing={4}
      columnSpacing={2}
      sx={{
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 4,
        maxWidth: "100vw",
      }}
    >
      {/*  Render the SampleRequestDetails component, passing necessary props */}
      <Grid item xs={12}>
        <SampleRequestDetails
          handleSubmit={props.handleSubmit}
          isSubmitting={props.isSubmitting}
        />
      </Grid>
      {/*  Conditionally render the ItemList component if sampleRequestDetails exists in the state */}
      {state.sampleRequestDetails && (
        <Grid item xs={12}>
          <ItemList data={state.sampleRequestDetails.items} />
        </Grid>
      )}
    </Grid>
  );
}
